import openSansLatinNormal from "@fontsource-variable/open-sans/files/open-sans-latin-wght-normal.woff2";
import openSansLatinItalic from "@fontsource-variable/open-sans/files/open-sans-latin-wght-italic.woff2";

export async function preloadFonts() {
	const fontsToPreload = [openSansLatinNormal, openSansLatinItalic];
	fontsToPreload.forEach((fontUrl) => {
		const link = document.createElement("link");
		link.rel = "preload";
		link.as = "font";
		link.href = fontUrl;
		link.type = "font/woff2";
		link.crossOrigin = "anonymous";
		document.head.appendChild(link);
	});
}
